import * as Services from "../services/Services"
import * as Url from "../services/Url"

export const getRulesByTenant = async(tenant_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_RULES+tenant_id, token)
  return res;
};

export const addRules = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_RULES, payload, token)
  return res;
};

export const updateRules = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_RULES}/${id}`, payload, token)
  return res;
};

